import { DatePicker } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { cn } from "sipli-fleet-core/utils/cn";
// import { getDateFormatByLocal } from "../../../src/utils/dateTime";

import CALENDER_ICON from "../../assets/icons/calender-icon.svg";
import { getDateFormatByLocal } from "../../utils/constants";

const { RangePicker } = DatePicker;

export interface CustomTimePickerProps extends RangePickerProps {
  className?: string;
}

const CustomTimePicker = ({
  className = "w-[296px] h-[32px]",
  allowClear = true,
  onChange,
  ...rest
}: CustomTimePickerProps) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleChange: RangePickerProps["onChange"] = (values, formatString) => {
    if (!values) {
      onChange?.(null, formatString);
      return;
    }

    onChange?.(values, formatString);
  };

  return (
    <RangePicker
      className={cn("custom-time-picker", className)}
      format={`${getDateFormatByLocal(currentLang)} HH:mm:ss`}
      placeholder={[t("start_date"), t("end_date")]}
      showTime={{
        format: "HH:mm:ss",
        defaultValue: [
          dayjs("00:00:00", "HH:mm:ss"),
          dayjs("23:59:59", "HH:mm:ss"),
        ],
      }}
      allowClear={allowClear}
      suffixIcon={<img src={CALENDER_ICON} alt="time_icon" />}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default CustomTimePicker;
